import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Schedule } from '@/features/accounts/types';
import { type ScheduleControls } from '@/features/accounts/schedule/hooks/useScheduleControls';
import ScheduleSubRow from './ScheduleSubRow';

interface Props {
  schedules: Schedule[];
  actions: ScheduleControls;
}

export default function ScheduleSubRows({ schedules, actions }: Props) {
  const [revealed, setRevealed] = useState(false);

  const shown = schedules.filter((schedule) => schedule.bookable);
  const heldBack = schedules.filter((schedule) => !schedule.bookable);

  return (
    <>
      {shown.map((schedule) => (
        <ScheduleSubRow key={schedule.id} schedule={schedule} actions={actions} />
      ))}

      {heldBack.length > 0 && (
        <tr className="bg-slate-50/50 border-t border-slate-100">
          <td colSpan={6} className="px-4 py-2 pl-12">
            <button
              type="button"
              onClick={() => setRevealed((open) => !open)}
              aria-expanded={revealed}
              className="text-sm font-medium text-slate-500 transition hover:text-slate-700"
            >
              <FormattedMessage
                id={revealed ? 'schedule.list.hideRest' : 'schedule.list.showRest'}
                values={{ count: heldBack.length }}
              />
            </button>
          </td>
        </tr>
      )}

      {revealed &&
        heldBack.map((schedule) => (
          <ScheduleSubRow key={schedule.id} schedule={schedule} actions={actions} />
        ))}
    </>
  );
}
